__webpack_require__.p = "https://file.wogoo.com/www/activity/";